import {
  Avatar,
  Box,
  Button,
  Flex,
  Text,
  Input,
  Select,
  Textarea,
  VStack,
  useToast,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
} from "@chakra-ui/react";
import DistPicker from "@/components/distpicker";
import ProfileBG from "@/assets/images/profile_bg.png";
import { useState } from "react";
import AreaType from "@/components/distpicker/areatype";
import ImageCropper from "@/components/cropper/cropper";
import { Field, Form, Formik, FormikErrors } from "formik";
import { UserProfile } from "@/types/user";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser, updateAvatar, selectAvatar } from "@/reducer/userslice";
import { ServerError } from "@/types/errors";
import {
  useUpdateUserMutation,
  useUpdateUserImageMutation,
  useUpdateUserBgImageMutation,
  useLazyGetMeQuery,
} from "@/services/api/endpoints/users";
import BgImageCropper from "@/components/cropper/bgimagecropper";
import { dataURLtoFile } from "@/utils/utils";

const Profile = () => {
  const user = useSelector(selectUser);
  const avatar = useSelector(selectAvatar)
  const dispatch = useDispatch();
  const toast = useToast();
  const [UpdateUser] = useUpdateUserMutation();
  const [updateUserImage] = useUpdateUserImageMutation();
  const [updateUserBgImage] = useUpdateUserBgImageMutation();
  const constellations = [
    "水瓶座",
    "双鱼座",
    "白羊座",
    "金牛座",
    "双子座",
    "巨蟹座",
    "狮子座",
    "处女座",
    "天枰座",
    "天蝎座",
    "射手座",
    "魔羯座",
  ];
  const [province, setProvince] = useState<AreaType>();
  const [city, setCity] = useState<AreaType>();
  const [area, setArea] = useState<AreaType>();
  const [personalBg, setPersonalBg] = useState(user.id ? `/api/v4/users/${user.id}/bgimage` : `${ProfileBG}`);
  // const [avatarSrc, setAvatarSrc] = useState(`/api/v4/users/${user.id}/image`)
  
  const form = {
    nickname: user.nickname || "",
    username: user.username || "",
    industry: user.industry || "",
    position: user.position || "",
    sex: user.sex || "",
    birthday: user.birthday || "",
    constellation: user.constellation || "",
    personal_sign: user.personal_sign || "",
    // province: ,
    // city: "",
    // area: "",
    address: user.address || "",
  } as UserProfile;

  const handleValidate = (values: UserProfile) => {
    const errors: FormikErrors<{
      nickname: string;
      username: string;
      industry: string;
      position: string;
      sex: string;
      birthday: string;
      constellation: string;
      personal_sign: string;
      address: string;
    }> = {};
    if (!values.nickname) {
      errors.nickname = "昵称不能为空";
    }
    if (!values.username) {
      errors.username = "用户名不能为空";
    }
    if (!values.industry) {
      errors.industry = "请选择行业";
    }
    if (!values.position) {
      errors.position = "岗位不能为空";
    }
    if (!values.sex) {
      errors.sex = "性别不能为空";
    }
    if (!values.birthday) {
      errors.birthday = "生日不能为空";
    }
    if (!values.constellation) {
      errors.constellation = "星座不能为空";
    }
    if (!values.personal_sign) {
      errors.personal_sign = "签名不能为空";
    }
    if (!values.address) {
      errors.address = "详细地址不能为空";
    }
    // if (!values.province) {
    //   errors.address = "省份不能为空";
    // }
    // if (!values.city) {
    //   errors.address = "城市不能为空";
    // }
    // if (!values.area) {
    //   errors.address = "区不能为空";
    // }
    return errors;
  };

  const handleSubmit = async (values: UserProfile) => {
    let postUserInfo = { ...values };

    postUserInfo.province = JSON.stringify(province) || user.province;
    postUserInfo.city = JSON.stringify(city) || user.city;
    postUserInfo.area = JSON.stringify(area) || user.area;
    postUserInfo.id = user.id;
    console.log(postUserInfo);
    const result = await UpdateUser(postUserInfo)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: false,
        });
      });
    if (result) {
      toast({
        title: '修改成功',
        position: "top",
        status: "success",
        duration: 2000,
        isClosable: false,
      });
      dispatch(updateUser(result));
    }
  };

  const hanleCropImage = async (value: string) => {
    //处理裁剪后的图片进行上传
    const file = dataURLtoFile(value, "image")
    const formData = new FormData()
    formData.append('image', file);
    const result = await updateUserImage({ userId: user.id, imageData: formData }).unwrap().catch((e) => {
      toast({
        title: (e as ServerError).message,
        position: "top",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    });
    if (result) {
      dispatch(updateAvatar(value))
    }
  };

  const hanleCropBgImage = async (value: string) => {
    //处理裁剪后的背景图片进行上传
    console.log('11111111111')
    const file = dataURLtoFile(value, "image")
    const formData = new FormData()
    formData.append('image', file);
    const result = await updateUserBgImage({ userId: user.id, imageData: formData }).unwrap().catch((e) => {
      toast({
        title: (e as ServerError).message,
        position: "top",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    });
    setPersonalBg(value)
  };

  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          个人资料
        </Box>
        <Formik
          initialValues={form}
          onSubmit={handleSubmit}
          validate={handleValidate}
        >
          {({ isSubmitting }) => (
            <Form>
              <Flex>
                <Box flex={1}>
                  <Flex mb="20px">
                    <Box flex={1}>
                      <Field name="nickname">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.nickname && form.touched.nickname
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#8E94A9"
                            >
                              昵称
                            </FormLabel>
                            <Input
                              {...field}
                              boxSizing="border-box"
                              border="1px solid #DCE0EB"
                              color={"#7F7F7F"}
                              fontSize="14px"
                              placeholder="请输入您的昵称"
                              size="md"
                            // value={nickname}
                            // onChange={(e) => setNickname(e.target.value)}
                            />
                            <FormErrorMessage>
                              {form.errors.nickname}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                    <Box flex={1} fontSize={"14px"} ml="30px">
                      <Field name="username">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.username && form.touched.username
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#8E94A9"
                            >
                              用户名
                            </FormLabel>
                            <Input
                              {...field}
                              boxSizing="border-box"
                              border="1px solid #DCE0EB"
                              color={"#7F7F7F"}
                              fontSize="14px"
                              placeholder="请输入"
                              size="md"
                            />
                            <FormErrorMessage>
                              {form.errors.username}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                  </Flex>
                  <Flex mb="20px">
                    <Box flex={1} fontSize={"14px"}>
                      <Field name="industry">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.industry && form.touched.industry
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#8E94A9"
                            >
                              行业
                            </FormLabel>
                            <Select
                              {...field}
                              w="100%"
                              boxSizing="border-box"
                              border="1px solid #DCE0EB"
                              color={"#7F7F7F"}
                              fontSize="14px"
                              placeholder="请选择您的行业"
                            // value={industry}
                            // onChange={(e) => setIndustry(e.target.value)}
                            >
                              <option value={"建筑业"}>建筑业</option>
                            </Select>

                            <FormErrorMessage>
                              {form.errors.industry}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                    <Box flex={1} fontSize={"14px"} ml="30px">
                      <Field name="position">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.position && form.touched.position
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#8E94A9"
                            >
                              岗位
                            </FormLabel>
                            <Select
                              {...field}
                              w="100%"
                              boxSizing="border-box"
                              border="1px solid #DCE0EB"
                              color={"#7F7F7F"}
                              fontSize="14px"
                              placeholder="请选择您的岗位"
                            // value={position}
                            // onChange={(e) => setPosition(e.target.value)}
                            >
                              <option value={"设计师"}>设计师</option>
                            </Select>
                            <FormErrorMessage>
                              {form.errors.position}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                  </Flex>
                  <Flex mb="20px">
                    <Box flex={1} fontSize={"14px"}>
                      <Field name="sex">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={form.errors.sex && form.touched.sex}
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#8E94A9"
                            >
                              性别
                            </FormLabel>
                            <Select
                              {...field}
                              placeholder="请选择您的性别"
                              boxSizing="border-box"
                              border="1px solid #DCE0EB"
                              color={"#7F7F7F"}
                              fontSize="14px"
                            // value={sex}
                            // onChange={(e) => setSex(e.target.value)}
                            >
                              <option value="男">男</option>
                              <option value="女">女</option>
                            </Select>
                            <FormErrorMessage>
                              {form.errors.sex}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                    <Box flex={1} fontSize={"14px"} ml={"30px"} mr={"30px"}>
                      <Field name="birthday">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.birthday && form.touched.birthday
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#8E94A9"
                            >
                              生日
                            </FormLabel>
                            <Input
                              {...field}
                              boxSizing="border-box"
                              border="1px solid #DCE0EB"
                              color={"#7F7F7F"}
                              fontSize="14px"
                              placeholder="请选择您的生日"
                              size="md"
                              type="date"
                            />
                            <FormErrorMessage>
                              {form.errors.birthday}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                    <Box flex={1} fontSize={"14px"}>
                      <Field name="constellation">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.constellation &&
                              form.touched.constellation
                            }
                          >
                            <FormLabel
                              mb={"10px"}
                              fontSize={"14px"}
                              color="#8E94A9"
                            >
                              星座
                            </FormLabel>
                            <Select
                              {...field}
                              boxSizing="border-box"
                              border="1px solid #DCE0EB"
                              color={"#7F7F7F"}
                              fontSize="14px"
                              placeholder="请选择您的星座"
                            // value={constellation}
                            // onChange={(e) => setConstellation(e.target.value)}
                            >
                              {constellations.map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </Select>
                            <FormErrorMessage>
                              {form.errors.constellation}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                  </Flex>
                </Box>
                <VStack mt={"30px"} mb={"30px"} ml="40px">
                  <Avatar
                    size="2xl"
                    src={avatar}
                    width={"120px"}
                    height={"120px"}
                    mb="20px"
                  />
                  <Box textAlign="center">
                    {/* <Text fontSize={"18px"} mb="20px">头像</Text> */}
                    {/* <Button borderRadius={"40px"} fontSize={"12px"} size='sm' w={"64px"}>修改头像</Button> */}
                    <ImageCropper getCropData={hanleCropImage} />
                    <Text fontSize={"12px"} mt={"12px"} mb={"10px"}>
                      您可以使用AI作品作为头像
                    </Text>
                  </Box>
                </VStack>
              </Flex>
              <Box mb="20px" fontSize={"14px"}>
                <Field name="personal_sign">
                  {({ field, form }: any) => (
                    <FormControl
                      isInvalid={
                        form.errors.personal_sign && form.touched.personal_sign
                      }
                    >
                      <FormLabel mb={"10px"} fontSize={"14px"} color="#8E94A9">
                        个性签名
                      </FormLabel>
                      <Textarea
                        {...field}
                        boxSizing="border-box"
                        border="1px solid #DCE0EB"
                        color={"#7F7F7F"}
                        fontSize="14px"
                        placeholder="请输入您的职业"
                        w={"100%"}
                      // value={personalSign}
                      // onChange={(e) => setPersonalSign(e.target.value)}
                      />
                      <FormErrorMessage>
                        {form.errors.personal_sign}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </Box>
              <Box mb="20px" fontSize={"14px"}>
                <Text mb={"10px"} color="#8E94A9">
                  邮寄地址
                </Text>
                <Flex>
                  <DistPicker
                    defaultProvince={user.province}
                    defaultCity={user.city}
                    defaultArea={user.area}
                    setProvice={setProvince}
                    setCity={setCity}
                    setArea={setArea}
                    isRequired={true}
                  />
                  <Box flex={1} ml={"20px"}>
                    <Field name="address">
                      {({ field, form }: any) => (
                        <FormControl
                          isInvalid={
                            form.errors.address && form.touched.address
                          }
                        >
                          <Input
                            {...field}
                            boxSizing="border-box"
                            border="1px solid #DCE0EB"
                            color={"#7F7F7F"}
                            fontSize="14px"
                            placeholder="请输入详细地址"
                            size="md"
                            w="100%"

                          // value={address}
                          // onChange={(e) => setAddress(e.target.value)}
                          />
                          <FormErrorMessage>
                            {form.errors.address}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </Box>
                </Flex>
              </Box>
              <Box mb="30px">
                <HStack>
                  <Text fontSize={"14px"} color="#8E94A9">
                    更换背景
                  </Text>
                </HStack>
                <BgImageCropper
                  saveCropData={hanleCropBgImage}
                  bgImgage={personalBg}
                />
                {/* <Image
                  w={"100%"}
                  h={"259px"}
                  src={ProfileBG}
                  mb={"20px"}
                  mt={"10px"}
                ></Image> */}
              </Box>
              <Flex mt={"20px"} mb={"43px"} justifyContent={"center"}>
                <Button
                  background={
                    "linear-gradient(81deg, #8E94A9 -3%, #27314D 100%)"
                  }
                  w={"460px"}
                  h={"50px"}
                  borderRadius={"0"}
                  // onClick={handleSave}
                  color="#FFFFFF"
                  fontSize={"18px"}
                  _hover={{
                    background:
                      "linear-gradient(81deg, #27314D -3%, #8E94A9 100%)",
                  }}
                  type="submit"
                  isLoading={isSubmitting}
                >
                  确认更改
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default Profile;
